import { render, staticRenderFns } from "./routeList.vue?vue&type=template&id=24a7b22c&scoped=true&"
import script from "./routeList.vue?vue&type=script&lang=js&"
export * from "./routeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7b22c",
  null
  
)

export default component.exports